import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import MasterBase from "../components/MasterLayout";
import { DeepCopy, isEmpty, isEnabled, getformid, getcontroller, getsubkey, setglobaldata } from '../modules/appLibrary';
import { changestatus, listtabs, listoption } from '../modules/formstore';
import {
    isKnownButUnimplementedRawPurchaseEntrySourceCategoryCode,
    normalizeRawPurchaseEntrySourceCategoryCode
} from './RawPurchaseEntryBase';
import { RawPurchaseEntryNone } from './RawPurchaseEntryNone';
import { RawPurchaseEntryRawShipDtl } from './RawPurchaseEntryRawShipDtl';
import { RawPurchaseEntryRawSalesIn } from './RawPurchaseEntryRawSalesIn';
import { RawPurchaseEntryRawIntTrade } from './RawPurchaseEntryRawIntTrade';
import { RawPurchaseEntryRawPurchase } from './RawPurchaseEntryRawPurchase';
import { RawPurchaseEntryRawSmplDel } from './RawPurchaseEntryRawSmplDel';

const RawPurchaseComFunc = React.forwardRef(ComFunction);

const ENTRY_COMPONENTS = {
    "": RawPurchaseEntryNone,
    "3": RawPurchaseEntryRawShipDtl,
    "5": RawPurchaseEntryRawSalesIn,
    "6": RawPurchaseEntryRawIntTrade,
    "7": RawPurchaseEntryRawPurchase,
    "9": RawPurchaseEntryRawSmplDel
};

export const RawPurchase = props => {
    const panelsdef = [];
    const defaultNavmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "print1", icon: "print", label: "原材料仕入伝票発行" },
    ];
    const formid = getformid("RawPurchase", props.location.search);
    const controller = getcontroller("RawPurchase", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const formstatus = useSelector(state => state.form.status);
    const modify = useSelector(state => state.form.modify);
    const formListOption = useSelector(state => state.form.listoption);
    const latestMaterialCategoryCode = useSelector(state =>
        String(state.form.entrydata?.ZSR_ZAIRYOKBN ?? "").trim()
    );

    const fnc = useRef();
    const baseRef = useRef();
    const entryRef = useRef();
    const entrydataRef = useRef(null);
    const listOptionViewSnapshotRef = useRef(null);

    const [activeEntrySourceCategoryCode, setActiveEntrySourceCategoryCode] = useState("");
    const [entryNavigationState, setEntryNavigationState] = useState(null);
    const [entryNavigationRequestKey, setEntryNavigationRequestKey] = useState(0);
    const [navmenu, setNavmenu] = useState(defaultNavmenu);

    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "0", action: "UPDATE" },
        { type: "1", action: "INSERT" },
        { type: "1", action: "UPDATE" },
    ];

    const dispatch = useDispatch();
    const search = useLocation().search;
    const actionurl = {
        "update": "Forms/Update",
        "getlist": "RawPurchase/GetListData",
    };

    function ResolveListMaterialCategoryCode(listOptionValue) {
        const candidates = [
            String(listOptionValue ?? "").trim(),
            latestMaterialCategoryCode
        ];

        for (let i = 0; i < candidates.length; i++) {
            if (candidates[i] === "") continue;
            return candidates[i];
        }

        return "";
    }

    function ResolveEntryMaterialCategoryCode() {
        const materialCategoryCode = String(entrydataRef.current?.ZSR_ZAIRYOKBN ?? "").trim();
        if (["1", "2", "3"].includes(materialCategoryCode)) {
            return materialCategoryCode;
        }
        return ResolveListMaterialCategoryCode("");
    }

    function OpenEmbeddedEntry(sourceCategoryCode, state) {
        setActiveEntrySourceCategoryCode(normalizeRawPurchaseEntrySourceCategoryCode(sourceCategoryCode));
        setEntryNavigationState(state);
        setEntryNavigationRequestKey(prev => prev + 1);
    }

    function HandleEntryNavmenuChange(entryNavmenu) {
        const nextNavmenu = defaultNavmenu.concat(Array.isArray(entryNavmenu) ? entryNavmenu : []);
        setNavmenu(prev => JSON.stringify(prev) === JSON.stringify(nextNavmenu) ? prev : nextNavmenu);
        if (!isEmpty(baseRef.current) && typeof baseRef.current.ChangeNavmenu === "function") {
            baseRef.current.ChangeNavmenu(nextNavmenu);
        }
    }

    function ResolvePrintReportController(action) {
        if (action === "print1") return "GenzairyoSiireReport";
        return "";
    }

    function PrintSelectedSlips(action) {
        const reportController = ResolvePrintReportController(action);
        if (reportController === "") return;

        const selectedRows = baseRef.current?.GetSelectrowdata() ?? [];
        if (selectedRows.length === 0) {
            fnc.current.warnmsg("対象データを選択してください");
            return;
        }

        const denNoList = [
            ...new Set(
                selectedRows
                    .map(row => String(row.ZSR_DENNO ?? "").trim())
                    .filter(value => value !== "")
            )
        ];

        if (denNoList.length === 0) {
            fnc.current.warnmsg("伝票番号が取得できません。");
            return;
        }

        fnc.current.postaxios(
            reportController + "/Generate",
            { denNoList: denNoList },
            {
                onSuccess: function (data) {
                    const params = {
                        excelfile: data.returnData["filename"],
                        dnfile: data.returnData["dnfile"]
                    };
                    fnc.current.filedownload("excel/ExcelDownload", params);
                    fnc.current.wait(false);
                },
                errmsg: "帳票の発行に失敗しました"
            }
        );
    }

    function Show(data, pushcode, listOptionValue) {

        let code = "";
        if (data === undefined || data === null) {
            if (!isEmpty(pushcode)) {
                code = pushcode;
            } else if (formstatus === "ENTRY FORM" && !isEmpty(entrydataRef.current?.ZSR_DENNO)) {
                code = String(entrydataRef.current.ZSR_DENNO).trim();
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (!isEmpty(data.ZSR_DENNO)) {
                code = data.ZSR_DENNO;
            }
        }

        if (code === "") {
            OpenEmbeddedEntry("", {
                status: "NEW",
                code: "",
                callerIdentifier: "RawPurchase",
                callerController: "RawPurchase",
                sourceCategoryCode: "",
                materialCategoryCode: ResolveListMaterialCategoryCode(listOptionValue)
            });
            return true;
        }

        fnc.current.wait(true);
        fnc.current.postaxios("RawPurchase/ResolveEntryRoute", { code: code },
            {
                onSuccess: function (result) {
                    const sourceCategoryCode = normalizeRawPurchaseEntrySourceCategoryCode(result?.returnData?.sourceCategoryCode ?? "");
                    if (isKnownButUnimplementedRawPurchaseEntrySourceCategoryCode(sourceCategoryCode)) {
                        fnc.current.warnmsg("選択した参照元区分の Entry 画面は未実装です。");
                        dispatch(changestatus("VIEW"));
                        fnc.current.wait(false);
                        return;
                    }

                    OpenEmbeddedEntry(sourceCategoryCode, {
                        status: "ENTRY",
                        code: code,
                        callerIdentifier: "RawPurchase",
                        callerController: "RawPurchase",
                        sourceCategoryCode: sourceCategoryCode
                    });
                    fnc.current.wait(false);
                },
                onError: function (result) {
                    const message = isEmpty(result?.errDescription) ? "処理中にエラーが発生しました" : result.errDescription;
                    fnc.current.warnmsg(message);
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            }
        );
        return true;
    }

    function HandleEntryAction(action, finallycallback, getList, gridApi) {
        if (
            formstatus === "VIEW" &&
            (action === "print1")
        ) {
            PrintSelectedSlips(action);
            return;
        }

        if (isEmpty(entryRef.current)) return;
        if (action === "save" && typeof entryRef.current.BuildSaveParam === "function" && typeof entryRef.current.Save === "function") {
            SaveEmbeddedEntry(finallycallback);
            return;
        }

        if (typeof entryRef.current.MenuAction !== "function") return;
        entryRef.current.MenuAction(action, finallycallback, getList, gridApi);
    }

    function HandleQueryAction(action) {
        if (formstatus !== "ENTRY FORM" || action !== "delete") return true;
        if (isEmpty(entryRef.current) || typeof entryRef.current.QueryAction !== "function") return true;
        return entryRef.current.QueryAction(action);
    }

    function SaveEmbeddedEntry(finallycallback) {
        entryRef.current.Save(finallycallback, false);
    }

    function HandleSourceCategoryNavigation(nextState) {
        const nextSourceCategoryCode = normalizeRawPurchaseEntrySourceCategoryCode(nextState?.sourceCategoryCode ?? "");
        if (isKnownButUnimplementedRawPurchaseEntrySourceCategoryCode(nextSourceCategoryCode)) {
            fnc.current.warnmsg("選択した参照元区分の Entry 画面は未実装です。");
            return;
        }
        OpenEmbeddedEntry(nextSourceCategoryCode, nextState);
    }

    function HandleEmbeddedEntryStatusAction(action) {
        const normalizedAction = String(action ?? "").trim().toUpperCase();
        const executeCancel = () => {
            if (!isEmpty(listOptionViewSnapshotRef.current)) {
                const current = isEmpty(entrydataRef.current) ? {} : entrydataRef.current;
                const restored = { ...current };
                Object.keys(listOptionViewSnapshotRef.current).forEach(key => {
                    restored[key] = DeepCopy(listOptionViewSnapshotRef.current[key]);
                });
                entrydataRef.current = restored;
            }
            listOptionViewSnapshotRef.current = null;
            fnc.current.modify(false);
            dispatch(changestatus("VIEW"));
        };

        if (normalizedAction === "CANCEL") {
            if (modify) {
                fnc.current.confmsg("編集内容は破棄されます。よろしいですか?", executeCancel);
                return;
            }
            executeCancel();
            return;
        }

        if (normalizedAction === "COPY") {
            dispatch(changestatus("COPY FORM"));
            return;
        }

        if (normalizedAction === "NEW") {
            const executeNew = () => {
                if (isEmpty(entryRef.current) || typeof entryRef.current.MenuAction !== "function") {
                    fnc.current.warnmsg("入力画面の初期化処理を呼び出せませんでした");
                    return;
                }
                OpenEmbeddedEntry("", {
                    status: "NEW",
                    code: "",
                    callerIdentifier: "RawPurchase",
                    callerController: "RawPurchase",
                    sourceCategoryCode: "",
                    materialCategoryCode: ResolveEntryMaterialCategoryCode()
                });
            };

            if (modify) {
                fnc.current.confmsg("編集内容は破棄されます。よろしいですか?", executeNew);
                return;
            }
            executeNew();
        }
    }

    const embeddedEntryStatusOptions =
        formstatus === "ENTRY FORM"
            ? ["CANCEL", "COPY", "NEW"]
            : (formstatus === "NEW FORM" || formstatus === "COPY FORM")
                ? ["CANCEL"]
                : null;

    const ActiveEntryComponent = isEmpty(entryNavigationState)
        ? null
        : (ENTRY_COMPONENTS[activeEntrySourceCategoryCode] || RawPurchaseEntryNone);

    return (
        <div>
            <RawPurchaseComFunc ref={fnc} />
            <MasterBase
                ref={baseRef}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
                entryform={true}
                entrycallback={HandleEntryAction}
                queryaction={HandleQueryAction}
                show={Show}
                suppressaction={suppressaction}
                entrystatusoptions={embeddedEntryStatusOptions === null ? undefined : embeddedEntryStatusOptions}
                entrystatusaction={embeddedEntryStatusOptions === null ? undefined : HandleEmbeddedEntryStatusAction}
            >
                {ActiveEntryComponent === null ? null :
                    <ActiveEntryComponent
                        {...props}
                        key={"RawPurchaseEntry_" + (activeEntrySourceCategoryCode === "" ? "None" : activeEntrySourceCategoryCode)}
                        ref={entryRef}
                        embedded={true}
                        navigationState={entryNavigationState}
                        navigationRequestKey={entryNavigationRequestKey}
                        onNavigateSourceCategory={HandleSourceCategoryNavigation}
                        onEntryNavmenuChange={HandleEntryNavmenuChange}
                        sharedListOption={formListOption}
                        sharedEntrydataRef={entrydataRef}
                    />}
            </MasterBase>
        </div>
    );
};
